import React, { useState, useEffect } from "react";
import Grid from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DropDownGrid from "../Grid/Components/DropDownGrid";
import {
    Box,
    MenuItem,
    ListItemIcon
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ListIcon from "@mui/icons-material/List";
import SettingsIcon from "@mui/icons-material/Settings";
import Cookies from "universal-cookie";
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from "react-router-dom";
import Search from "./Search";
import FormContainer from "./Form/FormContainer";
import BelongingsDialog from "./BelongingsDialog";
import MizanSettingsDialog from "./MizanSettingsDialog";
import Title from "./Title";
import { selectRoles } from "../../reduxStore/RolesReducer";
import mizanListAPI from "../../Network/MizanList";
import Swal from "sweetalert2";

const cookies = new Cookies();

export default function MizanList() {
    const maintheme = useSelector((state) => state.themeData.maintheme);
    const [t] = useTranslation("common");
    const [rows, setRows] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [loading, setLoading] = useState(false);

    const [pageCount, setPageCount] = useState(0);
    const [openFilterColumn, setOpenFilterColumn] = useState(false);
    const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);
    const [elementClicked, setElementClicked] = useState(null);

    const [filters, setFilters] = useState({
        name: "",
        code: "",
        municipality_ids: [],
        municipalities_selected: [],
        enabled: null,
    })
    const [reload, setReload] = useState(false)

    const [openForm, setOpenForm] = useState(false);
    const [selectedObject, setselectedObject] = useState(null);
    const [openBelongingsDialog, setOpenBelongingsDialog] = useState(false);
    const [belongingsObject, setBelongingsObject] = useState(null);
    const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
    const [settingsObject, setSettingsObject] = useState(null);

    const handlePageChange = (newPage) => {
        setPageNumber(newPage + 1);
    };

    const navigate = useNavigate();
    const controller = new AbortController();
    const [rowsTotal, setRowsTotal] = useState(0);
    const screenwidth = useSelector((state) => state.settingsData.screenwidth);

    const rolesRedux = useSelector(selectRoles)

    const columns = [
        { field: "id", headerName: "#", minWidth: 50, maxWidth: 100 },
        { field: "display_name", headerName: t("MIZAN_LIST.display_name") || "الاسم", minWidth: 150, maxWidth: 300, flex: 2 },
        { field: "code", headerName: t("MIZAN_LIST.code") || "الكود", minWidth: 100, maxWidth: 150, flex: 1 },
        { field: "municipality_name", headerName: t("MIZAN_LIST.municipality") || "البلدية", minWidth: 120, maxWidth: 200, flex: 1 },
        { field: "belongings_count", headerName: t("MIZAN_LIST.belongings_count") || "عدد الجهات", minWidth: 80, maxWidth: 120 },
        {
            field: "enabled", headerName: t("MIZAN_LIST.enabled") || "مفعل", minWidth: 80, maxWidth: 100,
            renderCell: (rows) => (
                <>
                    {rows?.row?.enabled ? (
                        <MenuItem onClick={() => { }} className="ActionIcons">
                            <ListItemIcon sx={{ display: "flex", justifyContent: "center", margin: "0px 7px 0 0" }}>
                                <CheckCircleIcon style={{ fill: "#388e3c" }} />
                            </ListItemIcon>
                        </MenuItem>
                    ) : (
                        <MenuItem onClick={() => { }} className="ActionIcons">
                            <ListItemIcon sx={{ display: "flex", justifyContent: "center", margin: "0px 7px 0 0" }}>
                                <DoDisturbOnIcon style={{ fill: "#d32f2f" }} />
                            </ListItemIcon>
                        </MenuItem>
                    )}
                </>
            )
        },
        {
            field: "total_units_count",
            headerName: t("MIZAN_LIST.total_units_count") || "عدد المركبات",
            minWidth: 100,
            maxWidth: 150,
            flex: 1,
            renderCell: (params) => (
                <span style={{ fontFamily: 'Cairo', fontSize: '14px', fontWeight: 'bold' }}>
                    {params?.row?.total_units_count ?? 0}
                </span>
            )
        },
        {
            field: "total_hosted_vehicle",
            headerName: t("MIZAN_LIST.total_hosted_vehicle") || "المركبات المستضافة",
            minWidth: 100,
            maxWidth: 150,
            flex: 1,
            renderCell: (params) => (
                <span style={{ fontFamily: 'Cairo', fontSize: '14px', fontWeight: 'bold', color: '#1976d2' }}>
                    {params?.row?.total_hosted_vehicle ?? 0}
                </span>
            )
        },
        {
            field: "total_external_vehicle",
            headerName: t("MIZAN_LIST.total_external_vehicle") || "المركبات الخارجية",
            minWidth: 100,
            maxWidth: 150,
            flex: 1,
            renderCell: (params) => (
                <span style={{ fontFamily: 'Cairo', fontSize: '14px', fontWeight: 'bold', color: '#d32f2f' }}>
                    {params?.row?.total_external_vehicle ?? 0}
                </span>
            )
        },
        {
            headerName: t("MIZAN_LIST.actions") || "الإجراءات",
            field: "Actions",
            flex: 0.5,
            minWidth: 120,
            hide: !rolesRedux?.view_master?.value,
            renderCell: (rows) => (
                <DropDownGrid>
                    {rolesRedux?.view_master?.value ? (
                        <MenuItem onClick={() => { updateFunction(rows?.row) }} className="ActionIcons">
                            <ListItemIcon sx={{ display: 'flex', justifyContent: 'center', margin: '0px 7px 0 0' }}>
                                <EditIcon style={{ fill: maintheme?.primary }} />
                            </ListItemIcon>
                            {t('GLOBAL.action_edit')}
                        </MenuItem>
                    ) : null}
                    {rolesRedux?.view_master?.value ? (
                        <MenuItem onClick={() => { openBelongings(rows?.row) }} className="ActionIcons">
                            <ListItemIcon sx={{ display: 'flex', justifyContent: 'center', margin: '0px 7px 0 0' }}>
                                <ListIcon style={{ fill: maintheme?.secondary || '#1976d2' }} />
                            </ListItemIcon>
                            {t('MIZAN_LIST.view_belongings') || 'عرض الجهات'}
                        </MenuItem>
                    ) : null}
                    {rolesRedux?.delete_master?.value ? (
                        <MenuItem onClick={() => { deleteFunction(rows?.row) }} className="ActionIcons">
                            <ListItemIcon sx={{ display: 'flex', justifyContent: 'center', margin: '0px 7px 0 0' }}>
                                <DeleteIcon style={{ fill: '#d32f2f' }} />
                            </ListItemIcon>
                            {t('GLOBAL.action_delete')}
                        </MenuItem>
                    ) : null}
                    {rolesRedux?.view_master?.value ? (
                        <MenuItem onClick={() => { openSettings(rows?.row) }} className="ActionIcons">
                            <ListItemIcon sx={{ display: 'flex', justifyContent: 'center', margin: '0px 7px 0 0' }}>
                                <SettingsIcon style={{ fill: '#6366f1' }} />
                            </ListItemIcon>
                            {t('MIZAN_LIST.settings') || 'الإعدادات'}
                        </MenuItem>
                    ) : null}
                </DropDownGrid>
            ),
        },
    ]

    useEffect(() => {
        loadData()
    }, [pageNumber, pageSize, reload]);

    const loadData = async (searchParams) => {
        if (cookies.get("active_session") && cookies.get("active_session") == "yes") {
            let object = {
                username: cookies.get("user_name") || null,
                user_id: cookies.get("user_id") || null,
                account_name: cookies.get("account_name") || null,
                account_id: cookies.get("account_id") || null,
                authHash: cookies.get("authHash") || null,
                sid: cookies.get("sid") || null,
                baseurl: cookies.get("baseUrl") || null,
                id: cookies.get("id") || null,
                page: pageNumber,
                page_size: pageSize,
                ...searchParams,
                name: filters?.name,
                code: filters?.code,
                enabled: filters?.enabled,
                municipality_ids: filters?.municipality_ids?.length > 0 ? JSON.stringify(filters.municipality_ids) : null,
            };

            setLoading(true);

            const result = await mizanListAPI.getMizanList({
                params: object,
                signal: controller?.signal,
            });
            setLoading(false);

            if (result.status && result?.data?.data?.data) {
                if (result?.data?.data?.data?.length > 0) {
                    setRows(result?.data?.data?.data);
                    setRowsTotal(result?.data?.data?.total_records);
                    setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
                } else {
                    setRows([]);
                    setRowsTotal(0);
                    setPageCount(0);
                }
            } else {
                if (result?.data?.data?.message) {
                    toast.error(result?.data?.data?.message?.text || result?.data?.data?.message)
                } else if (!result?.data?.error) {
                    toast.error(t("NETWORK_MESSAGES.unknownError"));
                }
                if (result?.data?.data?.message?.text == "unauthorized to complete") {
                    navigate("/redirect");
                }
            }
        } else {
            navigate("/redirect");
        }
    };

    const createFunction = () => {
        setselectedObject(null);
        setOpenForm(true);
    };
    const updateFunction = (obj) => {
        setselectedObject(obj)
        setOpenForm(true)
    }
    const openBelongings = (obj) => {
        setBelongingsObject(obj);
        setOpenBelongingsDialog(true);
    }
    const openSettings = (obj) => {
        setSettingsObject(obj);
        setOpenSettingsDialog(true);
    }
    const deleteFunction = async (obj) => {
        Swal.fire({
            title: t('GLOBAL.are_you_sure') || 'هل أنت متأكد؟',
            text: t('GLOBAL.delete_confirm') || 'لن تتمكن من التراجع عن هذا!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('GLOBAL.yes_delete') || 'نعم، احذفه!',
            cancelButtonText: t('GLOBAL.action_cancel') || 'إلغاء'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await mizanListAPI.deleteMizan({
                    id: obj.id,
                    params: {
                        username: cookies.get("user_name"),
                        user_id: cookies.get("user_id"),
                        account_name: cookies.get("account_name"),
                        account_id: cookies.get("account_id"),
                        sid: cookies.get("sid"),
                        baseurl: cookies.get("baseUrl"),
                        id: cookies.get("id"),
                    }
                });
                if (res.status && res?.data?.status) {
                    toast.success(t('NETWORK_MESSAGES.deleteSuccess') || 'تم الحذف بنجاح');
                    loadData();
                } else {
                    toast.error(res?.data?.data?.message?.text || t('NETWORK_MESSAGES.unknownError'));
                }
            }
        });
    }

    const clearFilterFunction = () => {
        setFilters({
            name: "",
            code: "",
            municipality_ids: [],
            municipalities_selected: []
        })
    }
    const searchFunction = () => {
        setReload(!reload)
        setPageNumber(1)
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                justifyContent: "center",
                alignItems: "start",
                overflowX: "hidden",
                "& .MuiChip-label": { fontFamily: "Cairo-Medium" },
            }}
        >
            {openForm ? (
                <FormContainer
                    object={selectedObject}
                    openForm={openForm}
                    setOpenForm={setOpenForm}
                    loadData={loadData}
                />
            ) : null}

            <BelongingsDialog
                open={openBelongingsDialog}
                setOpen={setOpenBelongingsDialog}
                mizan={belongingsObject}
            />

            <MizanSettingsDialog
                open={openSettingsDialog}
                setOpen={setOpenSettingsDialog}
                mizan={settingsObject}
            />

            <Grid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                loading={loading}
                handlePageChange={handlePageChange}
                rowsTotal={rowsTotal}
                checkScreenSize={screenwidth}
                pageCount={pageCount}
                openFilterColumn={openFilterColumn}
                elementClicked={elementClicked}
                setOpenFilterColumn={setOpenFilterColumn}
                setColumnFilterValue={setOpenFilterColumnValue}
                columFilterValue={openFilterColumnValue}
                clearFunction={clearFilterFunction}
                searchFunction={searchFunction}
                hasCreate={false}
                creatFunction={createFunction}
                LeftHeaderComponent={
                    <Title
                        createFunction={createFunction}
                        openFilterColumn={openFilterColumn}
                    />
                }
                filterChilds={
                    <Search
                        filters={filters}
                        setFilters={setFilters}
                    />
                }
            />
        </Box>
    );
}
